import { type Directive } from 'vue'
import { useAuthStore } from '../stores/auth-store'

/**
 * Directiva personalizada v-can para ocultar elementos basándose en permisos.
 *
 * Uso:
 * <button v-can="'create.products'">Crear Producto</button>
 * <div v-can="'view.sales'">Contenido de ventas</div>
 *
 * Si el usuario no tiene el permiso especificado, el elemento se oculta (display: none)
 *
 * @example
 * // En un componente
 * <button v-can="'update.products'" @click="handleEdit">Editar</button>
 * <button v-can="'delete.products'" @click="handleDelete">Eliminar</button>
 */
export const vCan: Directive = {
  mounted(el, binding) {
    const authStore = useAuthStore()
    const permission = binding.value

    if (typeof permission !== 'string') {
      return
    }

    if (!authStore.hasPermission(permission)) {
      // Ocultar elemento si no tiene permiso
      el.style.display = 'none'
      // Opcional: removerlo completamente del DOM
      // el.parentNode?.removeChild(el)
    }
  },

  updated(el, binding) {
    const authStore = useAuthStore()
    const permission = binding.value

    if (typeof permission !== 'string') {
      return
    }

    if (!authStore.hasPermission(permission)) {
      el.style.display = 'none'
    } else {
      // Restaurar display si ahora tiene permiso
      el.style.display = ''
    }
  },
}
